import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditableTextComponent } from './components/editable-text/editable-text.component';
import { PhonePipe } from './pipes/phone.pipe';
import { ToggleButtonsComponent } from './components/toggle-buttons/toggle-buttons.component';
import { AutocompleteInterfaceParserDirective } from './directives/autocomplete-interface-parser.directive';
import { KeepChipsExpandedDirective } from './directives/keep-chips-expanded.directive';
import { DebounceDirective } from './directives/debounce.directive';
import { HtmlStripePipe } from './pipes/html-strip.pipe';
import { ShrinkFileNamePipe } from './pipes/shrink-file-name.pipe';
import { AsksuiteCitrusModule } from 'asksuite-citrus';
import { IconComponent, ButtonV2Component, ButtonSophiaComponent } from 'asksuite-livechat-frontend-libs';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TranslateModule } from '@ngx-translate/core';
import { EmojiPickerComponent } from './components/emoji-picker/emoji-picker.component';
import { EmojiSuggestionComponent } from './components/emoji-suggestion/emoji-suggestion.component';
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { TagV2Component } from 'asksuite-livechat-frontend-libs'
import { BrowserWarningModalComponent } from './components/browser-warning-modal/browser-warning-modal.component';
import { AutocompleteInterfaceParserBoardDirective } from './directives/autocomplete-interface-parser-board.directive';


@NgModule({
  declarations: [
    EditableTextComponent,
    PhonePipe,
    ToggleButtonsComponent,
    AutocompleteInterfaceParserDirective,
    AutocompleteInterfaceParserBoardDirective,
    KeepChipsExpandedDirective,
    DebounceDirective,
    HtmlStripePipe,
    ShrinkFileNamePipe,
    EmojiPickerComponent,
    EmojiSuggestionComponent,
    BrowserWarningModalComponent,
  ],
  imports: [
    CommonModule,
    AsksuiteCitrusModule,
    ButtonV2Component,
    ButtonSophiaComponent,
    IconComponent,
    SpinnerComponent,
    TranslateModule,
    PickerComponent,
    TagV2Component
  ],
  exports: [
    EditableTextComponent,
    PhonePipe,
    ToggleButtonsComponent,
    AutocompleteInterfaceParserDirective,
    AutocompleteInterfaceParserBoardDirective,
    KeepChipsExpandedDirective,
    DebounceDirective,
    HtmlStripePipe,
    ShrinkFileNamePipe,
    ButtonV2Component,
    ButtonSophiaComponent,
    IconComponent,
    SpinnerComponent,
    EmojiPickerComponent,
    EmojiSuggestionComponent,
    BrowserWarningModalComponent,
    TagV2Component
  ],
})
export class SharedModule {}
